module.exports = __webpack_public_path__ + "static/media/marker.58d8a5ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pages/contact/marker.png
// module id = 231
// module chunks = 0